module.exports = __webpack_public_path__ + "img/pp2.8cbc3f24.png";